import { render, staticRenderFns } from "./Pdf2.vue?vue&type=template&id=3f668744&scoped=true&"
import script from "./Pdf2.vue?vue&type=script&lang=js&"
export * from "./Pdf2.vue?vue&type=script&lang=js&"
import style0 from "./Pdf2.vue?vue&type=style&index=0&id=3f668744&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f668744",
  null
  
)

export default component.exports